document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pw-hero').forEach(function (section) {
    var toggle = section.querySelector('[data-pw-hero-toggle]');
    var popup = section.querySelector('[data-pw-popup]');
    var closeBtn = section.querySelector('[data-pw-popup-close]');

    if (toggle && popup) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !popup.hasAttribute('hidden');

        if (isOpen) {
          popup.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          popup.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      document.addEventListener('click', function (e) {
        if (!section.contains(e.target)) return;
        if (popup.contains(e.target) || e.target === toggle) return;
        popup.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    if (closeBtn && popup) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        popup.setAttribute('hidden', '');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }
  });
});